import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Dashboard from './components/Dashboard';
import DispatchBoard from './components/DispatchBoard';
import Customers from './components/Customers';
import Drivers from './components/Drivers';
import DriverDetails from './components/DriverDetails';
import Orders from './components/Orders';
import Login from './components/Login';
import OrderTracking from './components/OrderTracking';
import OrderSearch from './components/OrderSearch';
import OrderPrint from './components/OrderPrint';
import DriverAccessLogin from './components/DriverAccessLogin';
import DriverAccessHome from './components/DriverAccessHome';

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // set document language and direction globally when language changes
    document.documentElement.lang = i18n.language || 'en';
    document.documentElement.dir = (i18n.language === 'ar') ? 'rtl' : 'ltr';
    document.documentElement.classList.toggle('rtl', i18n.language === 'ar');
    // set tab title dynamically
    document.title = t('Delivery Management');
    // set favicon/logo
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) favicon.href = '/dl.png';
  }, [i18n.language, t]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Dashboard />} />
        <Route path="/dispatch-board" element={<DispatchBoard />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/drivers" element={<Drivers />} />
        <Route path="/drivers/:id" element={<DriverDetails />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/print/:id" element={<OrderPrint />} />
        <Route path="/tracking" element={<OrderSearch />} />
        <Route path="/tracking/:id" element={<OrderTracking />} />
        <Route path="/driver" element={<DriverAccessLogin />} />
        <Route path="/driver/login" element={<DriverAccessLogin />} />
        <Route path="/driver/:username" element={<DriverAccessLogin />} />
        <Route path="/driver/home" element={<DriverAccessHome />} />
        <Route path="/driver-access/login" element={<DriverAccessLogin />} />
        <Route path="/driver-access" element={<DriverAccessHome />} />
      </Routes>
    </Router>
  );
}

export default App;
